import config from '@adc/configment'

/**
 * This will generate a url that will:
 *
 * (a) log you out of the related auction.com domain (thus removing APIAUTH on ADC domain)
 *   AND THEN
 * (b) log you out of morpheus (thus removing the APIAUTH on morpheus domain)
 *
 * This is done by redirecting the logout on ADC to the logout on morpheus.
 * The net effect is that when you log out of morpheus, it will log you out of ADC - which
 * in turn is to prevent any authentication weirdness that occurs when you (previously)
 * would log out of morpheus, but not be logged out as you still had the ADC cookie.
 *
 * NOTE: this feature requires the app's config has AUCTIONCOM_URL configured for all env's
 * and that config var is passed down to browser client (typically done in the app's
 * server controller.)
 */
export const getLogoutUrl = () => {
  const logoutRedirectPart = '/logout?redirect=/'
  const thisHost = `${location.protocol}//${location.host}`
  const adcHost = config.get('AUCTIONCOM_HOST', '')

  if (adcHost) {
    const redirectBackToApp = `${thisHost}${logoutRedirectPart}`
    return `${adcHost}/apps/logout?redirect=${redirectBackToApp}`
  } else {
    return logoutRedirectPart
  }
}
